// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  color: "#111827";
}
.ant-modal-header {
  border-bottom: none !important;
}
.ant-modal-body {
  padding-top: 16px !important;
}
.ant-modal-footer {
  border-top: none !important;
}
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #111827;
  padding: 0 15px;
}
.modal-container .tip-text {
  margin-bottom: 12px;
}
.modal-container .support-text {
  padding-top: 12px;
  border-top: 1px solid #d1d5db;
}
.modal-container .af-sharable-link {
  display: inline-block;
}
.modal-container .af-sharable-link span {
  color: #2563eb;
  text-decoration-line: underline;
  text-underline-offset: 4px;
}
.footer-buttons {
  display: flex;
  justify-content: center;
}
.footer-buttons button {
  width: 80px;
  height: 38px;
  background-color: #0076ff;
  border-color: #0076ff;
}
.footer-buttons button:hover,
.footer-buttons button:focus {
  background-color: #0076ff;
  border-color: #0076ff;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/StageParameterErrorModal/index.less"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAAF;AAEA;EACE,8BAAA;AAAF;AAGA;EACE,4BAAA;AADF;AAIA;EACE,2BAAA;AAFF;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAHF;AANA;EAWI,mBAAA;AAFJ;AATA;EAcI,iBAAA;EACA,6BAAA;AAFJ;AAbA;EAkBI,qBAAA;AAFJ;AAhBA;EAqBI,cAAA;EACA,+BAAA;EACA,0BAAA;AAFJ;AAMA;EACE,aAAA;EACA,uBAAA;AAJF;AAEA;EAII,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;AAHJ;AAJA;;EAUI,yBAAA;EACA,qBAAA;AAFJ","sourcesContent":["\n.modal-title {\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n  width: 100%;\n  color: \"#111827\";\n}\n.ant-modal-header {\n  border-bottom: none !important;\n}\n\n.ant-modal-body {\n  padding-top: 16px !important;\n}\n\n.ant-modal-footer {\n  border-top: none !important;\n}\n\n.modal-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #111827;\n  padding: 0 15px;\n  .tip-text {\n    margin-bottom: 12px;\n  }\n  .support-text {\n    padding-top: 12px;\n    border-top: 1px solid #d1d5db;\n  }\n  .af-sharable-link {\n    display: inline-block;\n  }\n  .af-sharable-link span {\n    color: #2563eb;\n    text-decoration-line: underline;\n    text-underline-offset: 4px;\n  }\n}\n\n.footer-buttons {\n  display: flex;\n  justify-content: center;\n  button {\n    width: 80px;\n    height: 38px;\n    background-color: #0076ff;\n    border-color: #0076ff;\n  }\n  button:hover, button:focus {\n    background-color: #0076ff;\n    border-color: #0076ff;\n  }\n}\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
